import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-races-m" }
const _hoisted_2 = { class: "classes-ul" }
const _hoisted_3 = { class: "classes-item" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

import useClasses from "@/composables/useClasses.ts";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let { classes } = useClasses();

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classes).data, (item, i) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          to: {
          name: 'classes',
          query: {
            i: i,
          },
        },
          key: i,
          custom: ""
        }, {
          default: _withCtx(({ navigate }) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", {
                class: "avatar",
                onClick: navigate
              }, [
                _createElementVNode("img", {
                  src: `${item.img}`,
                  alt: ""
                }, null, 8, _hoisted_5)
              ], 8, _hoisted_4),
              _createElementVNode("p", null, _toDisplayString(item.name), 1)
            ])
          ]),
          _: 2
        }, 1032, ["to"]))
      }), 128))
    ])
  ]))
}
}

})